import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, context) => {
        // This catches all throw createError() calls on the client and sends them to Sentry.
        Sentry.captureException(error);
    };
});
